export default __webpack_public_path__ + "1a38df6240eff5bba9770d3497f4923c.png";